module.exports = __webpack_public_path__ + "img/unfold.934f84d7.svg";